module.exports = __webpack_public_path__ + "img/400.6278664f.png";